import React from 'react';

const PrivacyPolicy = () => {
  return (
    <div className="min-h-screen bg-gray-50 py-8">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="bg-white shadow-lg rounded-lg p-8">
          <h1 className="text-3xl font-bold text-gray-900 mb-8 text-center">
            Privacy Policy
          </h1>
          
          <div className="prose prose-lg max-w-none">
            <p className="text-gray-700 mb-6">
              This Privacy Policy applies to PromPony our iOS and Android Mobile Applications (our "App"). 
              In the below policy, we inform you about the scope of the processing of your Personal Data.
            </p>

            <h2 className="text-2xl font-semibold text-gray-900 mt-8 mb-4">GENERAL INFORMATION</h2>
            
            <h3 className="text-xl font-medium text-gray-800 mt-6 mb-3">a) What law applies?</h3>
            <p className="text-gray-700 mb-4">
              Our use of your Personal Data is subject to Australia's Privacy Act and the 13 Privacy Principles ("APA"), 
              and the EU General Data Protection Regulation ("GDPR"), and of course we process your Personal Data accordingly.
            </p>

            <h3 className="text-xl font-medium text-gray-800 mt-6 mb-3">b) What is Personal Data?</h3>
            <p className="text-gray-700 mb-4">
              Personal Data is any information relating to personal or material circumstances that relates to an identified 
              or identifiable individual. This includes, for example, your name, date of birth, e-mail address, postal address, 
              or telephone number as well as online identifiers such as your IP address and device ID.
            </p>

            <h3 className="text-xl font-medium text-gray-800 mt-6 mb-3">c) What is processing?</h3>
            <p className="text-gray-700 mb-4">
              Processing means any operation or set of operations which is performed upon Personal Data, whether or not by 
              automatic means. The term is broad and covers virtually any handling of data.
            </p>

            <h3 className="text-xl font-medium text-gray-800 mt-6 mb-3">d) Who is responsible for data processing?</h3>
            <p className="text-gray-700 mb-4">
              The responsible party within the meaning of the APA and the GDPR is PromPony Enterprises Lessee Dancor Pty Ltd 
              of National Offices, 660 Burwood Road, Hawthorn East, Victoria 3123, Australia ("PromPony", "we", "us", or "our").​ 
              If you have any questions about this policy or our data protection practices, please contact us using hello@PromPony.com.
            </p>

            <h3 className="text-xl font-medium text-gray-800 mt-6 mb-3">e) The Legal Bases for processing Personal Data</h3>
            <p className="text-gray-700 mb-4">
              In accordance with the above-mentioned laws, we have to have at least one of the following legal bases to process 
              your Personal Data: a) you have given your consent, b) the data is necessary for the fulfilment of a contract / 
              pre-contractual measures, c) the data is necessary for the fulfilment of a legal obligation, or d) the data is 
              necessary to protect our legitimate interests, provided that your interests are not overridden.
            </p>

            <h2 className="text-2xl font-semibold text-gray-900 mt-8 mb-4">PROCESSING OF AUTOMATICALLY COLLECTED DATA</h2>
            
            <h3 className="text-xl font-medium text-gray-800 mt-6 mb-3">a) Downloading our App</h3>
            <p className="text-gray-700 mb-4">
              The App can be downloaded from the "Google Playstore'' a service offered by Google LLC, or the Apple App service 
              "App Store" a service of Apple Inc, to install our App. Downloading it may require prior registration with the 
              respective App store and/or installation of the respective App store software.
            </p>

            <h3 className="text-xl font-medium text-gray-800 mt-6 mb-3">b) Installing our App</h3>
            <p className="text-gray-700 mb-4">
              As far as we are aware, Google collects and processes the following data: Licence check, network access, network 
              connection, WLAN connections, and location information. However, it cannot be ruled out that Google also transmits 
              the information to a server in a third country. We cannot influence which personal data Google processes with your 
              registration and the provision of downloads in the respective App store and App store software. The responsible party 
              in this respect is solely Google as the operator of the Google Play Store.
            </p>
            <p className="text-gray-700 mb-4">
              As far as we are aware, Apple collects and processes the following data: device identifiers, IP addresses, location 
              information, it cannot be excluded that Apple also transmits the information to a server in a third country. We cannot 
              influence which personal data Apple processes with your registration and the provision of downloads in the respective 
              app store and app store software. The responsible party in this respect is solely Apple as the operator of the Apple App Store.
            </p>

            <h3 className="text-xl font-medium text-gray-800 mt-6 mb-3">c) Device information</h3>
            <p className="text-gray-700 mb-4">
              Google and Apple may collect information from and about the device(s) you use to access our App, including hardware 
              and software information such as IP address, device ID and type, device-specific and App settings and properties, 
              App crashes, advertising IDs (AAID), information about your wireless and mobile network connection such as your service 
              provider and signal strength; information about device sensors such as accelerometer, gyroscope, and compass and Payment 
              Data and Billing confirmations.
            </p>

            <h3 className="text-xl font-medium text-gray-800 mt-6 mb-3">d) Authorisations and Access</h3>
            <p className="text-gray-700 mb-4">
              We may request permission to store your App data including your Internet Connection and Network, Gallery, Image Storage 
              and Camera. The legal basis for data processing is our legitimate interest, the provision of contractual or pre-contractual 
              measures and your consent. You can deny access on your device via the Settings/Notifications/ options of your device; 
              however, this means that our App may not function as intended.
            </p>

            <h3 className="text-xl font-medium text-gray-800 mt-6 mb-3">e) Firebase</h3>
            <p className="text-gray-700 mb-4">
              We use the Google Firebase developer App and related features and services provided by Google. We use the following 
              Google Firebase services in our App: a) Firebase Analytics, and b) Firebase Crashlytics. By integrating Google services, 
              Google may collect and process information (including personal data). It cannot be excluded that Google also transfers 
              the information to a server in a third country. We cannot influence which data Google collects and processes. Firebase's 
              key security and privacy information can be found here: https://firebase.google.com/support/privacy The legal basis is 
              the implementation of the user contract for the use of the App.
            </p>

            <h3 className="text-xl font-medium text-gray-800 mt-6 mb-3">f) Crashlytics</h3>
            <p className="text-gray-700 mb-4">
              The app uses the tool Crashlytics to log crashes of our App. No personal data is transmitted. Only real-time crash 
              reports with precise details of code locations and device information are sent, which is intended to simplify maintenance 
              and improve the resulting stability of our App. The legal basis for data processing is our legitimate interest. In the 
              settings under data services, you can select whether you want to send crash reports or not.
            </p>

            <h3 className="text-xl font-medium text-gray-800 mt-6 mb-3">g) Google Analytics for Firebase</h3>
            <p className="text-gray-700 mb-4">
              Our App uses the web analytics service Google Analytics for Firebase, which uses tracking technologies to track your use 
              of our App. In this respect, information is generated about, among other things, the number of users and their sessions, 
              the session duration, the operating system used by the users, their device model, the region from which our App is accessed, 
              the first start of our App, our App execution and any updates.
            </p>
            <p className="text-gray-700 mb-4">
              In order to provide the relevant data for analysis, Firebase Analytics uses your a) device's advertising ID, b) an App 
              instance ID (a randomly generated number that identifies a single app installation), c) and the IP address, which is 
              shortened (IP masking) before being processed on Google's servers (which may be located outside the EEA) to generate 
              the usage analysis. You can object to the use of Firebase Analytics at any time by disabling the sending of usage 
              statistics in your device settings (Reset Advertising ID). We have no influence on these data processing operations. 
              The basis for processing is our legitimate interest and your consent.
            </p>

            <h2 className="text-2xl font-semibold text-gray-900 mt-8 mb-4">DATA PROCESSING BY US</h2>
            
            <h3 className="text-xl font-medium text-gray-800 mt-6 mb-3">a) Contacting us</h3>
            <p className="text-gray-700 mb-4">
              Personal data is processed depending on the contact method. In addition to your name and email address, IP address or 
              phone number, we usually collect the context of your message, which may also include certain Personal Data. The personal 
              data collected when you contact us is used to process your request and the legal basis is your consent.
            </p>

            <h3 className="text-xl font-medium text-gray-800 mt-6 mb-3">b) Providing our services</h3>
            <p className="text-gray-700 mb-4">
              The protection of your data is particularly important to us in the performance of our services. We therefore only want 
              to process as much Personal Data as is absolutely necessary. Nevertheless, we rely on the processing of certain Personal 
              Data, to fulfil our contractual obligations to you or to carry out pre-contractual measures.
            </p>

            <h3 className="text-xl font-medium text-gray-800 mt-6 mb-3">c) Registration</h3>
            <p className="text-gray-700 mb-4">
              If you register, we will request mandatory and, where applicable, non-mandatory data in accordance with our registration 
              form. The entry of your data is encrypted so that third parties cannot read your data when it is entered. Your data will 
              remain stored for as long as the registration lasts, in particular if the storage is necessary for the fulfilment/execution 
              of the contract, to enforce our rights or for our other legitimate interests or we are required by law to retain your data 
              (e.g., within the framework of tax retention periods or police prosecutions and investigations).
            </p>

            <h3 className="text-xl font-medium text-gray-800 mt-6 mb-3">d) Profile</h3>
            <p className="text-gray-700 mb-4">
              As a registered user, you have the opportunity to create a user profile with just a few clicks and details and the relevant 
              profile data you provide will be posted on your profile. Of course, you can change the information and delete your account 
              at any time via the settings in your profile. You have choices about the information on your profile. It's your choice 
              whether to include sensitive information on your profile and to make that sensitive information public. Please do not post 
              or add Personal Data to your profile that you would not want to be available. The legal basis for the processing of your 
              Personal Data is the establishment and implementation of the user contract for the use of our App.
            </p>

            <h3 className="text-xl font-medium text-gray-800 mt-6 mb-3">e) Using our App and providing Content</h3>
            <p className="text-gray-700 mb-4">
              If you wish to use our App and its features, we process the Personal Data you voluntarily provide for the purpose of 
              providing our App. Some of the Personal Data you provide may be considered "special" or "sensitive". This includes Personal 
              Data concerning for example your health data (Special Category Data). By choosing to provide this data, you consent to our 
              processing of that data. You have choices about the data you provide and how you share it. You don't have to provide Personal 
              Data or Special Category Data. It's your choice whether to include Personal Data or Special Category Data and to make that 
              information available to us. Please do not share information that you would not want to be available. The legal basis for 
              the processing of your Personal Data and Special Category Data is the establishment and implementation of the user contract 
              for the use of the service as well as your consent.
            </p>
            <p className="text-gray-700 mb-4">
              In providing our App and publishing your content including images we may process images and facial-related information from 
              our Users. Images and facial-related information are used and processed solely for the purpose explicitly consented to and 
              we do not collect, use, or store any images and facial-related information for the purpose of recognising faces outside of 
              this purpose. The legal basis is your consent.
            </p>

            <h3 className="text-xl font-medium text-gray-800 mt-6 mb-3">f) Aggregated Data</h3>
            <p className="text-gray-700 mb-4">
              We also collect, use and share Aggregated Data such as statistical or demographic data for any purpose including improving 
              our App and Services. Aggregated Data could be derived from your Personal Data but is not considered Personal Data in law 
              as this data will not directly or indirectly reveal your identity. However, if we combine or connect Aggregated Data with 
              your Personal Data so that it can directly or indirectly identify you, we treat the combined data as Personal Data which 
              will be used in accordance with this privacy policy.
            </p>

            <h3 className="text-xl font-medium text-gray-800 mt-6 mb-3">g) Administration, financial accounting, office organisation, contact management</h3>
            <p className="text-gray-700 mb-4">
              We process data in the context of administrative tasks as well as organisation of our business, and compliance with legal 
              obligations, such as archiving. In this regard, we process the same data that we process in the course of providing our 
              contractual services. The processing bases are our legal obligations and our legitimate interest.
            </p>

            <h3 className="text-xl font-medium text-gray-800 mt-6 mb-3">h) Payment Data</h3>
            <p className="text-gray-700 mb-4">
              If you take out a subscription your payment will be processed via the payment service provider Stripe, Apple or Google and 
              payment will solely be processed through the payment system of Stripe, Apple or Google as the case may be. The legal basis 
              for the provision of a payment system is the establishment and implementation of the user contract for the use of the service.
            </p>

            <h3 className="text-xl font-medium text-gray-800 mt-6 mb-3">i) Promotional use of your data</h3>
            <p className="text-gray-700 mb-4">
              We use your data within the legally permissible scope for marketing purposes, e.g., to draw your attention to special 
              promotions and discount offers. In addition, we may draw your attention to comparable offers by email, e.g., we may inform 
              you about exclusive sales, promotions, or special events. The legal basis for processing is our legitimate interest.
            </p>

            <h2 className="text-2xl font-semibold text-gray-900 mt-8 mb-4">GENERAL PRINCIPLES</h2>
            
            <h3 className="text-xl font-medium text-gray-800 mt-6 mb-3">a) What we do not do</h3>
            <ul className="list-disc pl-6 text-gray-700 mb-4">
              <li>We do not request Personal Data from minors and children without their explicit consent and we request that they seek permission from their parent or legal guardian if under 16 years of age;</li>
              <li>We do not process special category data without obtaining prior specific consent;</li>
              <li>We do not use Automated decision-making including profiling; and</li>
              <li>We do not sell your Personal Data.</li>
            </ul>

            <h3 className="text-xl font-medium text-gray-800 mt-6 mb-3">b) Sharing</h3>
            <p className="text-gray-700 mb-4">
              We will not disclose or otherwise distribute your Personal Data to third parties unless this is a) necessary for the 
              performance of our services, b) you have consented to the disclosure, c) or the disclosure of data is permitted by 
              relevant legal provisions. In addition, we may disclose your Personal Data: in connection with law enforcement, fraud 
              prevention or other legal proceedings; as required by law or regulation; if PromPony (or a part of PromPony) is sold 
              to or merged with another company; or if we have reason to believe that disclosure is necessary to protect our business.
            </p>

            <h3 className="text-xl font-medium text-gray-800 mt-6 mb-3">c) International Transfer</h3>
            <p className="text-gray-700 mb-4">
              We may transfer your Personal Data to other companies as necessary for the purposes described in this Privacy Policy. 
              In order to provide adequate protection for your Personal Data when it is transferred, we have contractual arrangements 
              regarding such transfers. We take all reasonable technical and organisational measures to protect the Personal Data we transfer.
            </p>

            <h3 className="text-xl font-medium text-gray-800 mt-6 mb-3">d) Data Security</h3>
            <p className="text-gray-700 mb-4">
              Our App uses SSL or TLS encryption to ensure the security of data processing and to protect the transmission of confidential 
              content, such as login data or contact requests that you send to us. We have also implemented numerous security measures 
              ("technical and organisational measures") for example encryption or need to know access, to ensure the most complete protection 
              of Personal Data processed through our App.
            </p>
            <p className="text-gray-700 mb-4">
              Nonetheless, databases or data sets that include Personal Data may be breached inadvertently or through wrongful intrusion. 
              Upon becoming aware of a data breach, we will notify all affected individuals whose Personal Data may have been compromised, 
              and the notice will be accompanied by a description of the action being taken to reconcile any damage as a result of the 
              data breach. Notices will be provided as expeditiously as possible after which the breach was discovered.
            </p>

            <h2 className="text-2xl font-semibold text-gray-900 mt-8 mb-4">YOUR RIGHTS AND PRIVILEGES</h2>
            
            <h3 className="text-xl font-medium text-gray-800 mt-6 mb-3">a) Privacy rights</h3>
            <p className="text-gray-700 mb-4">You can exercise the following rights:</p>
            <ul className="list-disc pl-6 text-gray-700 mb-4">
              <li>Right to information</li>
              <li>Right to rectification</li>
              <li>Right to object to processing</li>
              <li>Right to deletion</li>
              <li>Right to data portability</li>
              <li>Right to withdraw consent</li>
              <li>Right to complain to a supervisory authority</li>
              <li>Right not to be subject to a decision based solely on automated processing.</li>
            </ul>
            <p className="text-gray-700 mb-4">If you wish to exercise any of your rights, please contact us.</p>

            <h3 className="text-xl font-medium text-gray-800 mt-6 mb-3">b) Updating your information</h3>
            <p className="text-gray-700 mb-4">
              If you believe that the information we hold about you is inaccurate or that we are no longer entitled to use it and want 
              to request its rectification, deletion, or object to its processing, please do so by contacting us.
            </p>

            <h3 className="text-xl font-medium text-gray-800 mt-6 mb-3">c) Withdrawing your consent</h3>
            <p className="text-gray-700 mb-4">
              You can revoke consents you have given at any time by contacting us. The legality of the data processing carried out 
              until the revocation remains unaffected by the revocation.
            </p>

            <h3 className="text-xl font-medium text-gray-800 mt-6 mb-3">d) Access Request</h3>
            <p className="text-gray-700 mb-4">
              In the event that you wish to make a Data Subject Access Request, you may inform us in writing of the same. We will 
              respond to requests regarding access and correction as soon as reasonably possible. Should we not be able to respond to 
              your request within thirty (30) days after receiving your request, we will inform you in writing within thirty (30) days 
              of the time by which we will be able to respond to your request. If we are unable to provide you with any Personal Data 
              or to make a correction requested by you, we shall generally inform you of the reasons why we are unable to do so (except 
              where we are not required to do so under the respective legal regulations mentioned above).
            </p>

            <h3 className="text-xl font-medium text-gray-800 mt-6 mb-3">e) What we do not do</h3>
            <ul className="list-disc pl-6 text-gray-700 mb-4">
              <li>We do not request Personal Data from minors and children without their explicit consent and we request that they seek permission from their parent or legal guardian if under 16 years of age;</li>
              <li>We do not process special category data without obtaining prior specific consent;</li>
              <li>We do not use Automated decision-making including profiling; and</li>
              <li>We do not sell your Personal Data.</li>
            </ul>

            <h3 className="text-xl font-medium text-gray-800 mt-6 mb-3">f) Complaint to a supervisory authority</h3>
            <p className="text-gray-700 mb-4">
              You have the right to complain about our processing of Personal Data to a supervisory authority responsible for data protection. 
              The competent data protection authority in Australia is: The Office of the Australian Information Commissioner, GPO Box 5288 
              Sydney, NSW 2001, www.oaic.gov.au
            </p>

            <h2 className="text-2xl font-semibold text-gray-900 mt-8 mb-4">USER CONSENTS / MESSAGING</h2>
            <p className="text-gray-700 mb-4 italic">(Data rates may apply – check with your carrier)</p>
            
            <p className="text-gray-700 mb-4">
              By using the PromPony App you consent to us sending you messages, either by SMS, Chat, Email or other electronic means.
            </p>
            
            <p className="text-gray-700 mb-4">
              You can opt out of messages / limit frequency / control behaviour in your "Notification Settings" within the App and within 
              the controls within your electronic devices. Please note that some messaging is vital to the functioning of the App and your 
              interaction with it, any restrictions you apply to your settings may degrade your user experiences or have unintended consequences.
            </p>
            
            <p className="text-gray-700 mb-4">
              The frequency of messages you receive reflects your activity levels within the PromPony App when communicating with other Users / 
              Chat / Discussions, interacting with Service Providers or Advertisers. PromPony as the Platform Provider may communicate with 
              you electronically in any one of these forms, with Chat, SMS messages or emails, including (but not limited to):
            </p>

            <h3 className="text-xl font-medium text-gray-800 mt-6 mb-3">MANDATORY MESSAGING CONSENTS</h3>
            <p className="text-gray-700 mb-4 italic">(Frequency is Event driven / triggered and you cannot opt-out – you need to Delete the Account / App to stop these messages)</p>
            <ul className="list-disc pl-6 text-gray-700 mb-4">
              <li>App Signup validation of User Phone Number</li>
              <li>App Signup validation of User Email Address</li>
              <li>App Payments Functionality / validation of payment / banking details / transactional issues</li>
              <li>Dealing with reports of unsuitable platform behaviour</li>
              <li>Dealing with reports of illegal / fraudulent / misleading content</li>
              <li>Dealing with platform maintenance / outages / technical issues</li>
            </ul>

            <h3 className="text-xl font-medium text-gray-800 mt-6 mb-3">OPTIONAL MESSAGING CONSENTS</h3>
            <p className="text-gray-700 mb-4 italic">(Frequency is estimated up to 5 times per week, and limitations can be User applied via 'Notification Settings')</p>
            <ul className="list-disc pl-6 text-gray-700 mb-4">
              <li>Advising of new updates / features</li>
              <li>Advising of promotions / campaigns / advertising / competitions</li>
              <li>Advising of Job Vacancies / Events</li>
              <li>Communicating on behalf of our Advertiser / Seller / Service Provider Community</li>
            </ul>

            <p className="text-gray-700 mb-4">
              You can opt out at any time by Deleting the Account / App as the messaging is a part of the functional value of the User 
              Community. You can Block / Unblock any User at any time by going to the User Settings – " Block / Unblock"
            </p>

            <h2 className="text-2xl font-semibold text-gray-900 mt-8 mb-4">VALIDITY AND QUESTIONS</h2>
            <p className="text-gray-700 mb-4">
              This Privacy Policy was last updated on Thursday, 22nd of August 2024, and is the current and valid version. However, 
              from time to time changes or a revision to this policy may be necessary.
            </p>
            
            <p className="text-gray-700 mb-4">
              If you feel that the above is not sufficient or if you have any queries as regards the collection, processing or use of 
              your information we are looking forward to hearing from you. We will make every effort to reply as soon as possible and 
              take into consideration any suggestions from your end.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PrivacyPolicy; 